import { createStore } from "@stencil/store";
import { WorkoutSettings } from "@sworkit/api";
import { workoutSettingsDefaults } from "../components/shared/sw-workout-settings/workout-settings-utils";



const defaults: WorkoutSettings = workoutSettingsDefaults

const { state } = createStore({
  workoutSettings: {...defaults} as WorkoutSettings, 
});


const swWorkoutSettings = state;
export default swWorkoutSettings;

